<template>
  <div class="wrap wrap1">
    <!-- <Card class="box0">
      <span slot="title">拖拽排序</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh([getPostsList, getPostsListAll])">刷新</el-button>
      <div slot="content">
        <vuedraggable class="wrapper" v-model="postListSort">
          <transition-group>
            <el-tag v-for="item in postListSort" :key="item.postId">{{ item.postName }}</el-tag>
          </transition-group>
        </vuedraggable>
        <div class="btnwrap">
          <el-button type="success" icon="el-icon-finished" @click="savePostSort">保存排序</el-button>
        </div>
      </div>
    </Card> -->
    <Card class="box1">
      <span slot="title">科室管理</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh([getPostsList, getPostsListAll])">刷新</el-button>
      <div slot="content" class="wrap">
        <!-- 条件查询 -->
        <div class="search">
          <el-form :inline="true" :model="searchForm">
            <el-form-item label="科室名称">
              <el-input v-model="searchForm.postName" placeholder="请输入科室名称" />
            </el-form-item>
            <!-- <el-form-item label="科室编码">
              <el-input v-model="searchForm.postCode" placeholder="请输入科室编码"/>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"
                @click="$refresh([getPostsList, getPostsListAll], true)">查询</el-button>
              <el-button icon="el-icon-refresh"
                @click="$reset([getPostsList, getPostsListAll], { postName: null, postCode: null })">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 操作按钮 -->
        <div class="button">
          <el-button icon="el-icon-plus" type="primary" @click="addPost">新增科室</el-button>
          <!-- <el-button icon="el-icon-delete" type="danger" @click="deletePostList">批量删除</el-button> -->
        </div>
        <!-- 科室列表 -->
        <el-table v-loading="loading" :data="postList" ref="multipleTable"
          @selection-change="val => $handleSelectionChange(val, true)" border>
          <!-- <el-table-column type="selection" width="50"> </el-table-column> -->
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column prop="postName" label="名称" />
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              {{ scope.row.status == '0' ? '正常' : '停用' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="150" />
          <el-table-column label="操作" width="210">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="primary" @click="editPost(scope.row)">编辑</el-button>
              <el-button icon="el-icon-plus" @click="doctorEdit(scope.row)">绑定医生</el-button>
              <!-- <el-button icon="el-icon-delete" type="danger" @click="deletePost(scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增或编辑弹框 -->
        <el-dialog class="postEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="400px"
          :before-close="$handleClose" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editForm" label-width="80px" :rules="editFormRules" inline>
            <el-form-item label="科室名称" prop="postName">
              <el-input v-model="editForm.postName" placeholder="请输入科室名称" />
            </el-form-item>
            <el-form-item label="科室编码" prop="postCode">
              <el-input v-model="editForm.postCode" placeholder="请输入科室编码" />
            </el-form-item>
            <el-form-item label="科室状态" prop="status">
              <el-radio-group v-model="editForm.status">
                <el-radio :label="'0'">正常</el-radio>
                <el-radio :label="'1'">停用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="科室图片">
              <el-upload class="avatar-uploader" :action='action' list-type="picture-card"
                :on-success="handleAvatarSuccess" name="files" :on-remove="handleRemove" :with-credentials="true"
                :file-list="fileList" accept="image/*">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>

          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button type="success" v-if="dialogTitle == '新增科室'" @click="uploadPostImgAndEdit">保存新增</el-button>
            <el-button type="success" v-if="dialogTitle == '编辑科室'" @click="uploadPostImgAndEdit">保存修改</el-button>
            <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 医生弹框 -->
        <el-dialog class="doctor" title="医生列表" :visible.sync="doctorVisible" width="800px"
          :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
          <el-form class="mb20">
            添加医生：
            <el-select v-model="doctorIds" multiple filterable default-first-option placeholder="请选择医生">
              <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-button type="primary" @click="bindDoctor" class="ml20">绑定医生</el-button>
          </el-form>
          <el-table :data="doctorList" border stripe>
            <el-table-column type="index" label="序号" width="50" />
            <el-table-column prop="doctorName" label="姓名" />
            <el-table-column prop="sex" label="性别">
              <template slot-scope="scope">
                {{ scope.row.sex == '0' ? '男' : '女' }}
              </template>
            </el-table-column>
            <el-table-column prop="doctorTitle" label="医生职称" />
            <el-table-column prop="phone" label="联系电话" />
          </el-table>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button @click="$cancel('doctorVisible', 'editForm')">关闭</el-button>
          </span>
        </el-dialog>
        <!-- 分页 -->
        <el-pagination class="position-s"
          @current-change="page => $handleCurrentChange(page, [getPostsList, getPostsListAll])"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total" />
      </div>
    </Card>
  </div>
</template>

<script lang="js">
import vuedraggable from 'vuedraggable'; // 拖拽组件
import { postList, postEdit, postDelete, postAdd, postInfo, doctorData, saveDoctors, postDragSort, uploadTemporaryFile } from "@/api/post"; // 科室请求
import { isEmptyArray, isNull } from '../../../../utils/validateBase';
export default {
  name: "Depart",
  components: { vuedraggable },
  data() {
    return {
      loading: true, // 加载中
      searchForm: { postName: null, postCode: null, status: '0' }, // 查询表单
      postList: [], // 科室列表
      postListSort: [], // 所有科室
      currentPage: 1, // 当前页
      pageSize: 5, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      doctorVisible: false, // 医生列表弹框
      doctorList: [], // 已绑定医生列表
      doctorOptions: [], // 未绑定医生列表
      doctorIds: [], // 新的医生id
      curPostId: null, // 当前查看的科室id
      editFormRules: {
        postName: [{ required: true, message: "科室名称不能为空", trigger: "blur" }],
        postCode: [{ required: true, message: "科室编码不能为空", trigger: "blur" }],
        status: [{ required: true, message: "科室状态不能为空", trigger: "change" }]
      }, // 验证规则
      postImages: [],//科室icon
      fileList: [],
      action: this.$filePath + '/xl/upload/temp/file/upload',

    };
  },
  created() {
    this.getPostsList();// 获取科室列表分页
    this.getPostsListAll();// 获取科室列表分页
    this.$getDoctorOptions({ type: 0, status: 0 }); // 获取所有馆内在职医生
  },
  methods: {
    // 请求科室列表分页
    async getPostsList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await postList(params);
      if (code == 200) {
        this.total = total;
        this.postList = rows;
      }
      this.loading = false;
    },
    // 查询所有科室
    async getPostsListAll() {
      let { rows, code } = await postList();
      if (code == 200) this.postListSort = rows;
    },
    // 新增科室
    addPost() {
      this.dialogVisible = true;
      this.dialogTitle = "新增科室";
      this.editForm = { postName: null, postCode: null, status: '0', postImg: null };
      this.fileList = []
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          postAdd(this.editForm).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增科室成功！");

            this.dialogVisible = false;
            this.$refresh([this.getPostsList, this.getPostsListAll]);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑科室信息
    async editPost(row) {
      let { data, code } = await postInfo(row.postId);
      console.log(data);
      if (code == 200) {
        this.editForm = data;
        this.dialogTitle = "编辑科室";
        this.dialogVisible = true;
        if (data.postImg) {
          this.fileList = [{ name: data.postImg, url: data.postImg }]
        }
      }
    },
    // 保存科室修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          postEdit(this.editForm).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("修改科室成功！");

            this.dialogVisible = false;
            this.$refresh([this.getPostsList, this.getPostsListAll]);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除科室
    deletePost(row) {
      this.$confirm('确认删除该科室？').then(_ => { this.del(row.postId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await postDelete(id);
      if (code == 200) this.$message.success("删除科室成功！");
      this.$refresh([this.getPostsList, this.getPostsListAll]);
    },
    // 批量删除科室
    deletePostList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何科室");
      else {
        selected.forEach(item => { selectedId.push(item.postId) });
        this.$confirm('确认删除该科室？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    },
    // 查询医生
    async doctorEdit(row) {
      this.curPostId = row.postId;
      let { rows, total, code } = await doctorData(this.curPostId);
      this.doctorIds = [];
      if (code == 200) {
        if (total > 0) rows.forEach(item => { this.doctorIds.push(item.doctorId) });
        this.doctorList = rows;
        this.doctorVisible = true;
      }
    },
    // 绑定医生
    async bindDoctor() {
      let { code } = await saveDoctors({ postId: this.curPostId, doctorIds: this.doctorIds });
      if (code == 200) this.$message.success("医生绑定成功！");
      this.doctorVisible = false;
      this.$refresh([this.getPostsList, this.getPostsListAll]);
    },
    // 保存科室排序
    async savePostSort() {
      let { code } = await postDragSort(this.postListSort);
      if (code == 200) this.$message.success("科室排序成功！");
      this.$refresh([this.getPostsList, this.getPostsListAll]);
    },
    //上传科室icon
    handleAvatarSuccess(res, file, fileList) {
      console.log(88888888, res, file, fileList);
      if (res.errorCode == '0000') {
        this.postImages.push(res.data[0])
        this.fileList = fileList
        // console.log('this.fileList', this.fileList);
      }
    },
    handleRemove(res, file, fileList) {
      let fileId = res.response.data[0].fileId;
      this.postImages = this.postImages.filter((item) => { return item.fileId != fileId })
      // console.log('handleRemove', res, file, fileList);
    },
    async uploadPostImgAndEdit() {
      let obj = []
      this.postImages.forEach(v => {
        if (!isNull(v.fileId)) {
          obj.push({ uploadChannel: "postImg", fileId: v.fileId, groupName: "group1", isNeedThumbnail: "2" })
        }
      })
      // console.log('boj',obj);
      if (isEmptyArray(obj)) {
        if (this.dialogTitle == "编辑科室") {
          this.editSave()
          return
        } else if (this.dialogTitle == "新增科室") {
          this.addSave()
          return
        } else {
          return
        }
      } else {
        let res = await uploadTemporaryFile(obj)
        // console.log('uploadTemporaryFile',res);
        if (res.errorCode == '0000') {
          this.fileList = [];
          this.postImages = [];
          this.editForm.postImg = res.data[0].fullPathUrl
          if (this.dialogTitle == "编辑科室") {
            this.editSave()
            return
          } else if (this.dialogTitle == "新增科室") {
            this.addSave()
            return
          } else {
            return
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      }

    }
  },
};
</script>
<style lang="less" scoped>
.avatar-uploader {

  border: 1px dashed #999;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  /deep/ .el-upload--picture-card {
    width: 78px;
    height: 78px;
    line-height: 78px;
  }

  /deep/ .el-upload-list__item {
    width: 78px;
    height: 78px;
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}

.avatar {
  width: 78px;
  height: 78px;
  display: block;
}
</style>